import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import ReactModal from 'react-modal';
import { hideModal, getOwnLists } from 'appSrc/redux/actions';
import { dAPI } from 'appSrc/api';
import StepZero from './StepZero';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import { XIcon } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class ListCreationModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            initialStep: 1,
            listDetails: {
                title: '',
            },
        };
    }
    UNSAFE_componentWillReceiveProps( nextProps ) {
        if( nextProps.modalName ===  'listCreationModal' ) {
            if( nextProps.modalProps.initialStep !== undefined ) {
                this.setState( { step: nextProps.modalProps.initialStep, initialStep: nextProps.modalProps.initialStep } );
            }
        }
    }
    checkSlug = ( uslug, lslug, i ) => {
        var testSlug = ( i !== undefined ) ? lslug + i : lslug;
        var index = ( i !== undefined ) ? i + 1 : 0;
        return this.props.authorizeSlug( uslug, testSlug )
        .then( () => {
            return this.checkSlug( uslug, lslug, index );
        } )
        .catch( () => {
            return testSlug;
        } );
    }
    advanceStep = ( data ) => {
        var currentStep = this.state.step;

        switch ( currentStep ) {
            case 0:
                this.setState( { step: 1 } );
                break;
            case 1:
                this.setState( {
                    step: 2,
                    listDetails: {
                        ...this.state.listDetails,
                        ...data,
                    },
                } );
                break;
            case 2:
                this.setState( {
                    step: 3,
                    listDetails: {
                        ...this.state.listDetails,
                        ...data,
                    },
                } );
                break;
            case 3:
                var listData = {
                    ...this.state.listDetails,
                    ...data,
                };
                this.createNewList( listData );
                break;
        }

    }
    createNewList = ( listData ) => {
        this.setState( { fetching: true } );
        var list = {};
        var tags = [];
        this.checkSlug( this.props.user.slug, listData.title.replace( /[^0-9a-z]/gi, '' ).toLowerCase() )
        .then( ( validSlug ) => {
            var finalValues = {
                ...listData,
                slug: validSlug,
                user: this.props.user,
                curated: false,
                published: false,
            };
            return finalValues;
        } )
        .then( ( finalValues ) => {
            list = {
                title: finalValues.title,
                slug: finalValues.slug,
                description: finalValues.description,
                coverImage: finalValues.coverImage,
                youtube: finalValues.youtube,
                userid: finalValues.user.userid,
                curated: false,
                published: false,
                interests: finalValues.channel ? [ finalValues.channel ] : [],
                externalurl: finalValues.externalurl,
            };
            tags = finalValues.tags;

            return this.props.createNewList( list );
        } )
        .then( ( newList ) => {
            //handle adding tags
            var requests = [];
            for( var i = 0; i < tags.length; i++ ) {
                requests.push( this.props.addTag( newList.listid, tags[ i ].tagtext ) );
            }

            return Promise.all( requests )
            .then( () => { return newList; } );
        } )
        .then( ( newList ) => {
            list = newList;
            try {
                var coverType = !!list.youtube ? 'video' : !!list.coverImage ? 'image' : 'none';
                Mixpanel.track( 'listCreated', {
                    id: newList.listid,
                    name: newList.title,
                    user_id: newList.userid,
                    date_created: newList.dateCreated,
                    published: false,
                    like_count: 0,
                    // purchase_count: '?',
                    view_count: 0,
                    // search_count: 0,
                    // share_count: 0,
                    cover_type: coverType,
                    author: newList.userid,
                } );
            } catch (e) {
                console.warn( 'Analytics failure' );
            }
            return newList;
        } )
        .then( ( newList ) => {
            this.props.refreshLists();
            this.props.redirect( `/app/my-lists/${ newList.listid }/?tips=true` );
            this.props.closeModal();
            this.setState( { step: 1, listDetails: {}, fetching: false, initialStep: 1 } );
        } )
        .catch( ( error ) => {
            console.error( error );
            this.props.refreshLists();
            this.props.closeModal();
            this.setState( { step: 1, listDetails: {}, fetching: false, initialStep: 1 } );
        } );
    }
    stepBack = () => {
        this.setState( { step: this.state.step - 1 } );
    }
    closeModal = () => {
        this.setState( { step: 1, listDetails: {} } );
        this.props.closeModal();
    }
    render() {
        const { modalName, modalProps } = this.props;
        const { step, listDetails, fetching, initialStep } = this.state;

        var initialValues = { ...listDetails };
        if( step == 1 && initialValues.channel == [] ) {
            initialValues.channel = ( this.props.user.interests || [] ).map( interest => interest.interestid )[0] || null;
        }

        const intitialTitle = ( initialStep == 0 ) ? 'Now it’s your turn!' : 'Create a List';

        let goodToGo = modalName === 'listCreationModal';
        return (
            <ReactModal
            isOpen={ modalProps.modalIsOpen && goodToGo }
            contentLabel="Create New List"
            onRequestClose={ this.closeModal }
            className={ `modal-popup ${ style.listCreationModal }` }
            overlayClassName='modal-overlay' >
                { step > initialStep &&
                    <div className={ style.backIcon } onClick={ this.stepBack }>
                        Back
                    </div>
                }
                <div className='close-button' onClick={ this.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                { step == 0 &&
                    <StepZero onSubmit={ this.advanceStep } />
                }
                { step == 1 &&
                    <StepOne initialValues={ initialValues } title={ intitialTitle } onSubmit={ this.advanceStep } />
                }
                { step == 2 &&
                    <StepTwo initialValues={ initialValues } onSubmit={ this.advanceStep } />
                }
                { step == 3 &&
                    <StepThree onSubmit={ this.advanceStep } />
                }
                { fetching &&
                    <LoadingOverlay />
                }
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
        user: state.self.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        closeModal: () => {
            dispatch( hideModal( 'listCreationModal' ) );
        },
        redirect: ( url ) => {
            dispatch( push( url ) );
        },
        createNewList: ( data ) => {
            return dAPI.post( dAPI.self() + '/lists/', data, { headers: true } );
        },
        refreshLists: () => {
            return dispatch( getOwnLists() );
        },
        addTag: ( listid, newTag ) => {
            return dAPI.post( `/lists/${ listid }/tag`, { tag: newTag } );
        },
        authorizeSlug: ( uslug, lslug ) => {
            return dAPI.get( `/users/${ uslug }/lists/${ lslug }` );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )(ListCreationModal);
